import React, { useEffect, memo } from 'react';
import DemandPlannerSecMatGridTable from '../demand-planner-sec-mat/demandPlannerSecMatGridTable';
import { Loader } from '../../loader/index';

const DemandPlannerSecMatMsku = memo((props) => {

    useEffect(() => {
        props.fetchDemandPlannerSecMatSaleMsku();
    },
    //eslint-disable-next-line
     [])


    if (props.isDemandPlannerSecMatSaleMskuLoading) {
        return (
            <Loader flag={true} />
        )
    }
    else {
        return (
            <>
                {
                    props.data && props.data.map((item, ind) => (
                        <div key={`key${ind}`} style={{ padding: '16px', backgroundColor: 'white', marginTop: '16px' }}>
                            <DemandPlannerSecMatGridTable
                                normalData={item}
                                cotcData={null}
                                visibleList={['MonthVolume', 'Commulative', 'MonthlyGrowth', 'CommulativeGrowth', 'WeeklyRr']}
                                visibleListLabels={['Monthly Volume', 'Commulative', 'Monthly Growth', 'Commulative Growth', 'Weekly RR']}
                                hiddenList={['AwsGrowth', 'ADS', 'AdsGrowth']}
                                hiddenListLabels={['Aws Growth', 'ADS', 'ADS Growth']}
                                visibleList2={['QuarterVolume', 'QuarterGrowth', 'Seasonality']}
                                visibleList2Labels={['Quarterly Volume', 'Quarterly Growth', 'Seasonality']}
                                heading={item[0]}
                            />
                        </div>
                    ))
                }
            </>
        );
    }
})

export default DemandPlannerSecMatMsku;